import { DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { clearSession } from '../../redux/appSlice';
import AuthActions from '../../services/AuthActions';
import useLocalizedNavigate from '../../hooks/useLocalizedNavigate';

const { Text } = Typography;

const getUserName = (user, fallbackName) =>
  user?.name || user?.fullName || user?.email || fallbackName;

const AdminUserMenu = () => {
  const { t } = useTranslation();
  const navigate = useLocalizedNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser);
  const userName = getUserName(currentUser, t('WORD_ADMIN_USER'));

  const menuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: t('WORD_PROFILE'),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('WORD_LOG_OUT'),
    },
  ];

  const handleMenuClick = ({ key }) => {
    if (key === 'profile') {
      navigate('/profile/edit');
    }

    if (key === 'logout') {
      AuthActions.logout().finally(() => {
        dispatch(clearSession());
        navigate('/login');
      });
    }
  };

  return (
    <Dropdown
      trigger={['click']}
      placement="topRight"
      classNames={{ root: 'admin_user_dropdown' }}
      menu={{ items: menuItems, onClick: handleMenuClick }}
    >
      <button className="admin_sider_user" type="button" aria-label={userName}>
        <Avatar icon={<UserOutlined />} className="admin_user_avatar" />
        <span className="admin_sider_user_text">
          <Text strong>{userName}</Text>
        </span>
        <DownOutlined className="admin_sider_user_chevron" />
      </button>
    </Dropdown>
  );
};

export default AdminUserMenu;
